import BudgetProgress from './budget-progress';

export default BudgetProgress;
